import HomePage from './HomePage.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: {
      title: 'Accueil'
    }
  },
  {
    path: '/home',
    name: 'home-alt',
    component: HomePage,
    meta: {
      title: 'Accueil'
    }
  }
];

export default routes;
